import React from "react";
import "./AsianOdds.scss";
const AsianOddsEmpty = (): React.JSX.Element => {
  return (
    <div className="asian-odds-empty">
      <span className="asian-odds-empty__child">-</span>
    </div>
  );
};

export default AsianOddsEmpty;
